/**
 * Created by andrey on 21.05.2020
 */

const WindowBoostersBefore = function (level) {
    this.level = level;

    this.list = cleverapps.boosters.listBoostersBefore().map((booster) => new WindowBoosterBefore(booster, level));
};

WindowBoostersBefore.prototype.listSelected = function () {
    return this.list.filter((windowBooster) => windowBooster.isSelected() || (!cleverapps.config.features.includes("lantern_start") && windowBooster.isLantern()));
};

WindowBoostersBefore.prototype.listAfterStartActions = function () {
    return this.listSelected().map((windowBooster) => windowBooster.booster.getAfterStartActions());
};

WindowBoostersBefore.prototype.showTutorialSteps = function () {
    const steps = this.list.map((booster) => function (f) {
        booster.showTutorialStep(f);
    });

    new ActionPlayer(steps).play();
};

WindowBoostersBefore.isAvailable = function (options) {
    return cleverapps.user.checkAvailable(cleverapps.config.availables.BOOSTERS_BEFORE, options) && cleverapps.boosters.listBoostersBefore().length > 0;
};
